import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
    HEADER_CONFIG,
    HEADER_CONST
} from '../../common/constant/common-constant'
import { PAGE_CONST } from '../../common/constant/page-constant'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import { redirect } from '../../common/utils/redirectionUtils'
import MobileHeader from '../Common/Header/MobileHeader'

import './About.scss'
const About = props => {
    const navigate = useNavigate()
    const isMobile = useCheckMobileScreen()

    const [headerOptions, setHeaderOptions] = useState({
        [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
        [HEADER_CONFIG.TITLE]: HEADER_CONST.ABOUT,
        [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick()
    })

    return (
        <>
            {isMobile && <MobileHeader headerOptions={headerOptions} />}
            <div className="pageBodyRightPanel">
                <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter">
                    <div className="pageBodyRightPanelHeading">About Us</div>
                </div>
                <div className="informationCondition">
                    <p className="infoPara">
                        <strong>DG HealthCare</strong>, the first concern of DIPON Group in the health sector, is dedicated to developing innovative digital solutions. It is the first to introduce these advanced health-tech services in Bangladesh. DG ePharma is one of its flagship health-tech products. DIPON group is a leading and prestigious business house originating in Bangladesh came into existence in 1970 with the formation of Dipon Gas Company Ltd with the specific objective of providing end-to-end solutions in oil and gas pipeline construction works.
                    </p>

                    <p className="infoPara">
                        Since its inception, DIPON have grown manifolds. It has diversified its business activity in Engineering and Construction, Project Investment and Developments, Shipping and Logistics as well as IT and ITES.
                    </p>

                    <p className="infoPara">
                        DIPON has ventured outside of Bangladesh and established its presence in India, Singapore, Malaysia, UAE, Saudia Arabia and African countries through their regional and project offices.
                    </p>

                    <p className="infoPara">
                        <strong>DG ePharma</strong> is a comprehensive digital marketplace (B2C & B2B) and POS solution tailored to support pharmacies across Bangladesh in growing their business both online and in-store. By using this platform, Pharmacies can get online orders from customers and can place orders to pharmaceutical manufacturers.
                    </p>

                    <p className="infoPara">
                        <strong>Key Features:</strong>
                    </p>
                    <ul className="featuresList">
                        <li>Dynamic dashboard for performance insights</li>
                        <li>On-demand delivery service for medicines and complementary products to your customers</li>
                        <li>Real-time accounting, sales and transaction reports for better financial visibility</li>
                        <li>Inventory and stock management, including expired product tracking</li>
                        <li>Cloud-based access from any device to keep all data secured</li>
                        <li>Multiple branch connectivity for centralized operations</li>
                        <li>Digital payment and receipt system (VS Challan)</li>
                        <li>User access control management</li>
                        <li>Dedicated customer service for troubleshooting</li>
                    </ul>
                    <br />

                    <address className="addressAnchor">
                        <strong>DG e-Pharma</strong> <br />
                        Address: Rangs FC Enclave (Level 11), Plot 6/A, Road no 32, Gulshan Avenue, Dhaka-1212
                        <br />
                        E-mail:{' '}
                        <a
                            className="action"
                            href="mailto:dghealthcare@dipon.com.bd">
                            dghealthcare@dipon.com.bd
                        </a>
                        <br />
                        Website:{' '}
                        <a className="action" href="https://dghealthcare.online/" target="_blank" rel="noopener noreferrer">
                            DG Healthcare
                        </a>
                    </address>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    return {}
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(About)
